import ValidateEntityObject from '@/shared/utils/validate-entity-object';
import WorkItemType from './work-item-type.entity';

type AssignedTo = {
  id: string;
  userName: string;
  status: string;
};

export default class WorkItemSummary {
  id: string;

  workItemNumber: number;

  status: string;

  title: string;

  workItemType: WorkItemType;

  createdDate: Date;

  originCreatedDate: Date;

  estimatedDeadLine: Date;

  createdBy: string;

  assignedTo: AssignedTo;

  originalEstimate: number;

  storyPoints?: number;

  effortSpent: number;

  originSystem: string;

  concludedAt: string;

  expanded?: boolean;

  error: string;

  definitionType?: string;

  projectControlName: string;

  isSelected: boolean = false;

  delivery?: boolean;

  vstsIntegrationBlocked: boolean = false;

  description?: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.createdDate = obj.createdDate;
    this.originCreatedDate = obj.originCreatedDate;
    this.originSystem = obj.originSystem;
    this.title = obj.title;
    this.workItemNumber = obj.workItemNumber;
    this.estimatedDeadLine = obj.estimatedDeadLine;
    this.createdBy = obj.createdBy;
    this.workItemType = ValidateEntityObject.validate(obj.workItemType, WorkItemType.of);
    this.status = obj.status;
    this.originalEstimate = obj.originalEstimate;
    this.storyPoints = obj.storyPoints;
    this.effortSpent = obj.effortSpent || 0;
    this.assignedTo = obj.assignedTo;
    this.concludedAt = obj.concludedAt || '';
    this.error = obj.error || '';
    this.definitionType = obj.definitionType || '';
    this.projectControlName = obj.projectControlName || '';
    this.isSelected = obj.isSelected || false;
    this.delivery = obj.delivery || false;
    this.vstsIntegrationBlocked = obj.vstsIntegrationBlocked || false;
    this.description = obj.description || '';
  }

  public static of(value: any): WorkItemSummary {
    return new WorkItemSummary(value || {});
  }

  public static ofList(response: any): WorkItemSummary[] {
    return response.map(this.of);
  }

  public get deliveryFormatted(): string {
    return this.delivery ? 'YES' : 'NO';
  }
}
